import React from 'react';
import { connect } from 'react-redux';
import cookies from 'react-cookies';
import { showPlank, hidePlank } from '~/src/store/actions/plank';
import { getMobileLink, isMobile } from '~/src/helpers/mobile';

const CONFIG = {};

export const location = [
  '/',
  '/user/login',
  '/payments',
  '/payments/lost',
  '/promo',
  '/action/pr',
  '/service/feedback',
  '/service/contact',
  '/service/agent',
  '/service/document',
  '/service/helper',
];

export const smartHomeLocations = [
  '/domofon',
  '/videocontrol',
  '/payments/keys',
];
export const excludeLocations = ['/speed-test'];

class Plank extends React.Component {
  state = {
    isOpen: true,
  };

  CONFIG = {
    maxAge: 60 * 24 * 60 * 60,
    domain: this.props.domain,
    path: '/',
  };

  handleCloseLink = (e) => {
    e.preventDefault();
    const { accessToken, refreshToken, agreement, city } = this.props;
    cookies.save('notification_mobile_app', 1, CONFIG);
    this.setState({ isOpen: false });
    this.props.hidePlank();
    if (!smartHomeLocations.includes(window.location.pathname)) {
      window.location = getMobileLink(
        accessToken,
        refreshToken,
        agreement,
        city
      );
    }
  };

  handleClosePlank = (e) => {
    e.preventDefault();
    cookies.save('notification_mobile_app', 1, CONFIG);
    this.setState({ isOpen: false });
    this.props.hidePlank();
  };

  checkMobilePlankType = () => {
    return <></>;
  };

  get isExcludePath() {
    return excludeLocations.includes(window.location.pathname);
  }

  URLCheck = () => {
    const { isAuth, showPlank, hidePlank } = this.props;
    const params = window.location.search
      .replace('?', '')
      .split('&')
      .reduce(function(p, e) {
        var a = e.split('=');
        p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
        return p;
      }, {});

    if (
      isMobile() &&
      !cookies.load('notification_mobile_app') &&
      window.innerWidth < 861 &&
      !this.isExcludePath
    ) {
      if (isAuth && !params['utm_source']) {
        showPlank();
        return this.checkMobilePlankType();
      } else if (
        (location.includes(window.location.pathname) &&
          !params['utm_source']) ||
        (smartHomeLocations.includes(window.location.pathname) &&
          !params['utm_source'])
      ) {
        showPlank();
        return this.checkMobilePlankType();
      } else {
        hidePlank();
      }
    } else {
      hidePlank();
    }
  };

  render() {
    return <div id={'plankMobile'}>{this.URLCheck()}</div>;
  }
}

const mapStateToProps = (state) => ({
  isAuth: state.auth.isAuth,
  accessToken: state.auth.accessToken,
  refreshToken: state.auth.refreshToken,
  agreement: state.auth.clientPersonal?.agreement,
  city: state.city.currentCity,
});

const mapDispatchToProps = (dispatch) => ({
  showPlank: () => dispatch(showPlank()),
  hidePlank: () => dispatch(hidePlank()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Plank);
